import React from 'react';
import { updateObject, updateObjectProperty, updateSection } from './storeFunctions';
import { getScrollY } from './almightyElementWrapper'

let _actions = {
    _name: 'WINDOWS',
    LOCATION_CHANGE: '@@router/LOCATION_CHANGE' // hardcoded to save 9KB lib link just to get one value
}
_actions = Object.assign(_actions, {
    OPEN: _actions._name + '_OPEN',
    CLOSE_ALL: _actions._name + '_CLOSE_ALL',
    CLOSE: _actions._name + '_CLOSE',
    TOGGLE_DRAG: _actions._name + '_TOGGLE_DRAG'
})

const initialState = {

};
const windowInitial = {
    id:undefined, 
    component:undefined, componentProps:{}, 
    onInitialize:() => {}, onOpen:() => {}, onClose:() => {}, 
    isOpen:false, isInitialized:false, dragAllowed:false, dragEnabled:false,
    position:{x:0, y:0}
}

const actionMap = {
    [`${_actions.OPEN}`]: (state,data) => _openWindow(state, data),
    [`${_actions.CLOSE}`]: (state,data) => _closeWindow(state, data),
    [`${_actions.TOGGLE_DRAG}`]: (state, data) => _toggleDrag(state, data),
    [`${_actions.CLOSE_ALL}`]: (state, data) => _closeAll(state, data),
    [`${_actions.LOCATION_CHANGE}`]: (state, data) => _closeAll(state, data)
}

function _openWindow(state, data) {
    if(data.id === undefined) { return state; }
    if(state[data.id] === undefined) { state[data.id] = {...windowInitial, ...data}; }
    if(!state[data.id].isInitialized) {
        state[data.id].dragEnabled = state[data.id].dragAllowed;
        state[data.id].offset = _calculatePinOffset(data.openData.windowPin)
        state[data.id].position = _calculatePosition(data.openData.element, data.openData.parentPin);
        state[data.id].onInitialize();
        state = updateObject(state, {[`${data.id}`]: {...state[data.id], isInitialized:true}})
    }

    state = updateObject(state, {[`${data.id}`]: {...state[data.id], isOpen:true}});
    state[data.id].onOpen();
    return state;
}

function _closeAll(state, data) {
    const keys = Object.keys(state);
    for (let keyId = 0; keyId < keys.length; keyId++) {
        const key = keys[keyId];
        if(state[key] === undefined || state[key] === null || !state[key].isOpen) {
            continue;
        }
        state[key].onClose();
        state = updateObject(state, {[`${key}`]: undefined});
    }
    return state;
}

function _calculatePosition(element, pin) {
    const rect = (element || window.document.body).getBoundingClientRect();
    const scrollY = getScrollY();
    switch((pin || '').toLowerCase()) {
        case 'left-top':
        case 'top-left':
            return {x:rect.left, y:rect.top+scrollY};
        case 'left-center': 
            return {x:rect.left, y:rect.top+scrollY+(rect.height/2)};
        case 'left-bottom':
        case 'bottom-left':
            return {x:rect.left, y:rect.top+scrollY+rect.height};
        case 'bottom-center':
            return {x:rect.left+(rect.width/2), y:rect.top+scrollY+rect.height};
        case 'bottom-right':
        case 'right-bottom':
            return {x:rect.left+rect.width, y:rect.top+scrollY+rect.height};
        case 'right-center':
            return {x:rect.left+rect.width, y:rect.top+scrollY+(rect.height/2)};
        case 'right-top':
        case 'top-right':
            return {x:rect.left+rect.width, y:rect.top+scrollY};
        case 'top-center':
            return {x:rect.left+(rect.width/2), y:rect.top+scrollY};
        default: return {x:rect.left, y:rect.top+scrollY};
    }
}

function _calculatePinOffset(pin) {
    switch((pin || '').toLowerCase()) {
        case 'left-top':
        case 'top-left':
            return '0, 0';
        case 'left-center': 
            return '0, -50%';
        case 'left-bottom':
        case 'bottom-left':
            return '0, -100%';
        case 'bottom-center':
            return '-50%, -100%';
        case 'bottom-right':
        case 'right-bottom':
            return '-100%, -100%';
        case 'right-center':
            return '-100%, -50%';
        case 'right-top':
        case 'top-right':
            return '-100%, 0';
        case 'top-center':
            return '-50%, 0';
        default: return '-50%, -50%'
    }
}

function _closeWindow(state, data) {
    if(data.id === undefined || state[data.id] === undefined || !state[data.id].isOpen) { return state; }
    state[data.id].onClose();
    state = updateObject(state, {[`${data.id}`]: undefined});
    return state;
}

function _toggleDrag(state, data) {
    if(data.id === undefined || state[data.id] === undefined || !state[data.id].isOpen || !state[data.id].dragAllowed) { return state; }
    return updateObject(state, {[`${data.id}`]: {...state[data.id], dragEnabled: !state[data.id].dragEnabled}});
}

function _isAnyOpen(id, state) {
    const keys = Object.keys(state)
    if(id === null || id === undefined) {
        return keys.filter(x => state[x] !== null && state[x] !== undefined && state[x].isOpen).length > 0;
    }
    const key = keys.filter(x => x.toLowerCase() === id.toLowerCase());
    return key.length > 0 && state[key[0]] !== null && state[key[0]] !== undefined && state[key[0]].isOpen;
}

export const reducer = (state, action) => {
    state = state || initialState;
    if(Object.keys(actionMap).indexOf(action.type) !== -1) {
        return actionMap[action.type](state,action.data)
    }
    return state;
}

export const windowActions = {
    openWindow: (id, dragAllowed, component, componentProps, openData) => async (dispatch, getState) => dispatch({
        type:_actions.OPEN, data:{id, dragAllowed, component, componentProps, openData:{element:undefined, parentPin:'center', windowPin:'center', ...openData}
    }}),
    closeWindow: (id) => async (dispatch) => dispatch({type:_actions.CLOSE, data:{id}}),
    toggleDrag: (id) => async (dispatch) => dispatch({type:_actions.TOGGLE_DRAG, data:{id}}),
    closeAll: () => async(dispatch) => dispatch({type:_actions.CLOSE_ALL}),
    isOpen: (id) => (dispatch,getState) => _isAnyOpen(id, getState().windows)
}